import * as React from "react";
import {deleteModuleInstance} from "../../BackendFacade/apiCalls";
import {HubPathRouting} from "../../../../HubFramework/pathBuilder";
import {useMain} from "../../../../Utils/SessionControls/mainContext";
import OdxModal from '../../../../OdxComponents/NativeOdx/Modal/Odx-Modal'
import OdxChip from '../../../../OdxComponents/NativeOdx/Odx-Chip'
import OdxRadioButton from '../../../../OdxComponents/NativeOdx/FormControls/Odx-RadioButton'
import {NetworkData} from "../../../../BackendFacade";
import {simplifyForHtmlId} from "../../../../Utils/transformer";

interface IProps {
    onSuccessFunction: (response: NetworkData)  => void,
    closeFunction: () => void,
    moduleInstanceId: string,
    moduleTitle: string,
    isOpen: boolean
}

export enum DeleteMode {
    softDelete,
    hardDelete
}

const DeleteModule: React.FC<IProps> = ({
                                                 moduleInstanceId,
                                                 closeFunction,
                                                 onSuccessFunction,
                                                 moduleTitle,
                                                 isOpen
                                             }) => {

	    const {setLoading, createErrorToast, createToast} = useMain();
	    const [deleteMode, setDeleteMode] = React.useState(DeleteMode.softDelete);
	    const [confirmDelete, setConfirmDelete] = React.useState(false);
	    const baseId = `project-delete-module-${simplifyForHtmlId(moduleInstanceId)}`;
	    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
	        setDeleteMode(event.target.value === 'softDelete' ? DeleteMode.softDelete : DeleteMode.hardDelete);
	    };

    const deleteModuleInstance_Local = () => {
        setLoading(true)
        deleteModuleInstance(HubPathRouting.currentProject.id, moduleInstanceId, deleteMode).then((data) => {
            setLoading(false)
            if (data.success) {
                onSuccessFunction(data)
                closeFunction()
                createToast({message: data.message, variant: "success", title: "Successfully deleted module"})
            } else {
                createErrorToast(data.message)
            }
        })
    }

	    return <div>
	        {confirmDelete &&
	            <OdxModal
	                onClose={() => closeFunction()}
	                onBackButtonClick={() => setConfirmDelete(false)}
	                size={"medium"} title={"Are you sure you want to delete?"}
	                id={`${baseId}-confirm`}
                footerButtons={[
                    <odx-button
                        key={2}
                        variant="danger"
                        size="lg"
                        type="button"
                        id={`${baseId}-confirm-delete-btn`}
                        onClick={() => deleteModuleInstance_Local()}
                    >
                        Delete
                    </odx-button>,
                    <odx-button
                        key={1}
                        variant="ghost"
                        size="lg"
                        type="button"
                        onClick={() => closeFunction()}
                    >
                        Cancel
                    </odx-button>
                ]}
	                isOpen={true} variant={"default"}>
	                <div id={`${baseId}-confirm-body`}></div>
	            </OdxModal>}

	        {!confirmDelete &&
	            <OdxModal size={"medium"} title={"Delete " + moduleTitle} onClose={() => closeFunction()} footerButtons={
                [
                    <odx-button
                        key={1}
                        variant="ghost"
                        size="lg"
                        type="button"
                        onClick={() => closeFunction()}
                    >
                        Cancel
                    </odx-button>,
                    <odx-button
                        key={2}
                        variant="danger"
                        size="lg"
                        type="button"
                        id={`${baseId}-initial-delete-btn`}
                        onClick={() => setConfirmDelete(true)}
                    >
                        Delete
                    </odx-button>
                ]
	            } isOpen={isOpen} variant={"default"} id={baseId}>
	                <OdxChip size={"small"} content={"Recommended"} id={`${baseId}-recommended-chip`}/>
	                <OdxRadioButton
	                    className={"!pb-3.5 !pt-3.5"}
	                    name="deleteMode"
	                    value="softDelete"
	                    id={`${baseId}-soft-option`}
	                    label="Soft Delete"
	                    checked={deleteMode === DeleteMode.softDelete}
	                    onChange={() => setDeleteMode(DeleteMode.softDelete)}
	                />
	                <hr/>
	                <OdxRadioButton
	                    className={"!pt-3.5"}
	                    name="deleteMode"
	                    value="hardDelete"
	                    id={`${baseId}-hard-option`}
	                    description={"This will delete all data and cannot be undone!"}
	                    label="Hard Delete"
	                    checked={deleteMode === DeleteMode.hardDelete}
	                    onChange={() => setDeleteMode(DeleteMode.hardDelete)}
                />
            </OdxModal>}
    </div>;

}

export default DeleteModule;
